import { render, staticRenderFns } from "./SFTPFilesCollapse.vue?vue&type=template&id=75666fd2&scoped=true&"
import script from "./SFTPFilesCollapse.vue?vue&type=script&lang=js&"
export * from "./SFTPFilesCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SFTPFilesCollapse.vue?vue&type=style&index=0&id=75666fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75666fd2",
  null
  
)

export default component.exports